import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';
import { useFirestore } from './useFirestore';
import firebase from 'config/firebase';
import { stateIsLoaded } from 'services/stateHelpers';
import { updateUsersLoginInfo } from 'redux/actions/internal/general/users';
import { collection } from 'services/db/firestoreApi';
import { isEmpty } from 'lodash';
import { useExecutor } from './useExecutor';

export const useCustomerLoginStream = () => {
    const usersLoginInfo = useSelector((state: RootState) => state.usersLoginInfo);
    const customersRef = useFirestore('customers');
    const currentUser = useSelector((state: RootState) => state.currentUser);
    const dispatch = useDispatch();

    const verifyEmailExecutor = useExecutor('/customers/verifyEmail');

    return {
        registerCustomer: async (id: string) => {
            await verifyEmailExecutor.post({
                uid: id,
            });
            const customerWithSamePhone = await collection('customers', {
                queries: [
                    {
                        attribute: 'phone.fullNumber',
                        operator: '==',
                        value: usersLoginInfo.data.phone.fullNumber,
                    },
                ],
            });
            return customersRef.set(id, {
                firstName: usersLoginInfo.data.name,
                lastName: usersLoginInfo.data.lastName,
                email: usersLoginInfo.data.email,
                phone: usersLoginInfo.data.phone,
                addresses: {
                    [customersRef.id()]: {
                        fullAddress: usersLoginInfo.data.address.fullAddress,
                        location: new firebase.firestore.GeoPoint(
                            usersLoginInfo.data.address.latitude,
                            usersLoginInfo.data.address.longitude
                        ),
                        city: 'Skopje',
                        streetNumber: '/',
                        accommodation: 'apartment',
                        entranceNumber: '/',
                        doorPin: '/',
                        apartmentNumber: '/',
                        // createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                        isDefault: isEmpty(customerWithSamePhone),
                        approved: false,
                    },
                },
                favorites: [],
                type: 'default',
            });
        },
        customerExistsInFirestore: async (phone?: string) => {
            const data = await collection('customers', {
                queries: [
                    {
                        attribute: 'phone.fullNumber',
                        operator: '==',
                        value: phone,
                    },
                ],
            });
            return stateIsLoaded(currentUser);
        },
        saveAuthUserInLoginState: () => {
            const user = firebase.auth().currentUser;
            if (user) {
                dispatch(
                    updateUsersLoginInfo({
                        phone: {
                            countryCode: '',
                            phoneNumber: '',
                            fullNumber: `${user.phoneNumber}`,
                        },
                    })
                );
            }
        },
    };
};
